export default __webpack_public_path__ + "static/media/questionMarkLBIcon.456f6608.svg";